
export var forbiddenWords = [
  'lopovi', 'lopine', 'lopov', 'kurac','kurcina','kurcinu', 'kurcine', 'prevara','govno','govna' ,'pusi', 
  'majmuni','mamu', 'jebem', 'jebes', 'jebeni', 'kradja', 'pljacka', 'peder', 'pedercina','gejcina', 'gay',
  'anal','cmar','guzica','kopile','kucka','krvavo','grudi','skitnica','klitoris','kurac','sranje','picka',
  'dildo','jebac','ejakulacija','jebati','jebeno','proklet','pakao','drkanje','orgazam','penis','pisanje',
  'odjebi','porno','pornografija','silovanje','silovatelj','rektum','retard','sadist','kuckin','vagina','viagra',
  'vulva','kurva'
];



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/chat-forbidden-words.js
// module id = 840
// module chunks = 11